module.exports = __webpack_public_path__ + "static/img/bgGray.24db63e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bgGray.png
// module id = clRM
// module chunks = 55